import { BE_SELECTABLE_AS } from '@shared/core/search/entities/businessEntity';
import { useCallback, useState } from 'react';
import { AgButton, AgInput, AgModal, AgModalActions, AgModalContent } from 'src/components/ui';
import { BusinessEntityMultiPicker } from 'src/modules/entities/search';
import { CustomerGroupsMeta } from './constants';
import useCreateCustomerGroup from './hooks/useCreateCustomerGroup';
import useUpdateCustomerGroup from './hooks/useUpdateCustomerGroup';

type CustomerGroupDialogProps = { group: Partial<CustomerGroupsMeta>; close: () => void };

export default function CustomerGroupDialog({ group, close }: CustomerGroupDialogProps) {
  const [name, setName] = useState(group?.name ?? '');
  const [customers, setCustomers] = useState(
    group?.customers?.map((c) => ({ name: c.name, businessEntityId: c.id })) ?? []
  );

  const createCustomerGroup = useCreateCustomerGroup();
  const updateCustomerGroup = useUpdateCustomerGroup();
  const isNameBlank = !name.trim();

  const onSubmit = useCallback(() => {
    if (!group.id) {
      createCustomerGroup({ name, customers: customers.map((c) => c.businessEntityId) });
    } else {
      updateCustomerGroup(group.id, { name, customers: customers.map((c) => c.businessEntityId) });
    }
    close();
  }, [close, createCustomerGroup, customers, group.id, name, updateCustomerGroup]);

  return (
    <AgModal open onClose={close} title={group ? 'New customer group' : 'Edit customer group'} size="md">
      <AgModalContent>
        <div className="flex flex-col gap-4">
          <AgInput label="Customer group name" isRequired value={name} onChange={(value) => setName(value)} />
          <BusinessEntityMultiPicker
            filter={BE_SELECTABLE_AS('CUSTOMER')}
            value={customers}
            label="Group members"
            onChange={setCustomers}
          />
        </div>
      </AgModalContent>
      <AgModalActions>
        <AgButton variant="primary" isDisabled={isNameBlank} onPress={() => onSubmit()}>
          Save
        </AgButton>
      </AgModalActions>
    </AgModal>
  );
}
